import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperRef } from 'antd-mobile';
import { SlideModal } from '@/components';
import { storagePrefixFixedV2 } from '@/constant';

import cx from './index.module.scss';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isRealTimeMode: boolean;
}

const GUIDE_VIDEOS = [
  {
    poster: storagePrefixFixedV2 + '/image/immer-mode/imer-guide-poster.png',
    videoUrl: storagePrefixFixedV2 + '/videos/h264/immermode-guide-1.mp4',
  },
  {
    poster: storagePrefixFixedV2 + '/image/immer-mode/immer-bg-3.png',
    videoUrl: storagePrefixFixedV2 + '/videos/h264/immermode-guide-2.mp4',
  },
];

const REAL_MODE_VIDEOS = [
  {
    poster: storagePrefixFixedV2 + '/image/immer-mode/real-mode-poster-1-min.png',
    tipText: '在实时模式界面下，可以点击「沉浸&实时」切换按钮来切换模式',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/real-time-guide-1.mp4',
  },
  {
    poster: storagePrefixFixedV2 + '/image/immer-mode/real-mode-poster-1-min.png',
    tipText: '在实时模式界面下，可以点击「音乐」图标来切换疗愈音乐',
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/real-time-guide-2.mp4',
  },
  {
    poster: storagePrefixFixedV2 + '/image/immer-mode/real-mode-poster-1-min.png',
    tipText: (
      <div>
        当理疗舒适时，可以点击「爽」图标，通过语音“小易师傅太舒服了”
        <br />
        小易师傅会记录下您的舒适点。
      </div>
    ),
    videoUrl: storagePrefixFixedV2 + '/videos/immer-mode/real-time-guide-3.mp4',
  },
];

const GuideModal: React.FC<Props> = ({ open, setOpen, isRealTimeMode }) => {
  const [controlShow, setControlShow] = useState(false);
  const swiperRef = useRef<SwiperRef>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setControlShow(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  // eslint-disable-next-line fuxi/require-useEffect-before-return
  useEffect(() => {
    let timer: number;
    if (!open) {
      timer = window.setTimeout(() => {
        // 增加额外的保护：确保 ref 存在且当前组件确实没有被卸载（隐式保护）
        if (swiperRef.current) {
          try {
            swiperRef.current.swipeTo(0);
          } catch (e) {
            console.warn('Swiper reset failed:', e);
          }
        }
      }, 200);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open]);

  if (!controlShow) return null;

  return (
    <SlideModal className={cx('GuideModal')} open={open} onClickMask={() => setOpen(false)}>
      <div className={cx('modal-box')}>
        <div className={cx('title')}>
          <div>沉浸模式操作引导</div>
          <div className={cx('close-text')} onClick={() => setOpen(false)}>
            完成
          </div>
        </div>
        <div className={cx('swiper')}>
          {isRealTimeMode ? (
            <Swiper ref={swiperRef}>
              {
                REAL_MODE_VIDEOS.map(item => (
                  <Swiper.Item className={cx('swiper-item')} key={item?.poster}>
                    <div className={cx('img-container-3')}>
                      <div className={cx('tips')}>{item.tipText}</div>
                      <video preload="auto" poster={item.poster} src={item.videoUrl} muted autoPlay loop />
                    </div>
                  </Swiper.Item>
                )) as any
              }
              <Swiper.Item className={cx('swiper-item')}>
                <div className={cx('img-container-2', 'real-mode-item-1')}>
                  <div className={cx('tips')}>可以使用语音指令来控制小易师傅</div>
                  <img className={cx('tip-img')} src={storagePrefixFixedV2 + '/image/immer-mode/real-time-tip.png'} />
                </div>
              </Swiper.Item>
            </Swiper>
          ) : (
            <Swiper ref={swiperRef}>
              <Swiper.Item className={cx('swiper-item')}>
                <div className={cx('img-container-1')}>
                  <div className={cx('tips')}>请将平板放置理疗床下方，确保顾客可以清晰观看</div>
                  <video
                    preload="auto"
                    poster={GUIDE_VIDEOS[0].poster}
                    src={GUIDE_VIDEOS[0].videoUrl}
                    muted
                    autoPlay
                    loop
                  />
                </div>
              </Swiper.Item>
              <Swiper.Item className={cx('swiper-item')}>
                <div className={cx('img-container-2')}>
                  <div className={cx('tips')}>可以使用语音指令来控制小易师傅</div>
                  <img className={cx('tip-img')} src={storagePrefixFixedV2 + '/image/video-cover/adadada.png'} />
                </div>
              </Swiper.Item>
              <Swiper.Item className={cx('swiper-item')}>
                <div className={cx('img-container-3')}>
                  <div className={cx('tips')}>在沉浸模式界面下，可以左右滑动来切换疗愈音乐</div>
                  <video
                    preload="auto"
                    poster={GUIDE_VIDEOS[1].poster}
                    src={GUIDE_VIDEOS[1].videoUrl}
                    muted
                    autoPlay
                    loop
                  />
                </div>
              </Swiper.Item>
            </Swiper>
          )}
        </div>
      </div>
    </SlideModal>
  );
};

export default GuideModal;
